

export interface PromptConfig {
  system: string;
  region: string;
  focus: string;
  customModifier: string;
  plane: string;
  view: string;
  zoom: string;
  style: string;
  lighting: string;
  background: string;
  referenceImageUrl?: string; // Base64 string for uploaded sketch
  videoUrl?: string; // URL for generated video
}

export type MediaType = 'IMAGE' | 'VIDEO';

export interface GeneratedImage {
  id: string;
  url: string; // Base64 data URL or Blob URL
  prompt: string;
  timestamp: number;
  label?: string; // For series identification
  mediaType: MediaType;
}

export interface Annotation {
  id: string;
  targetX: number; // Percent 0-100
  targetY: number; // Percent 0-100
  labelX: number;  // Percent 0-100
  labelY: number;  // Percent 0-100
  text: string;
}

export interface SelectionRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface SavedPreset {
  id: string;
  name: string;
  timestamp: number;
  config: PromptConfig;
}

export enum AppMode {
  SINGLE = 'SINGLE',
  SERIES = 'SERIES',
}

export enum ToolMode {
  POINTER = 'POINTER', // For labeling
  INPAINT = 'INPAINT', // For selecting regions to edit
}

// Taxonomy Data Structures
export interface TaxonomySystem {
  name: string;
  regions: TaxonomyRegion[];
}

export interface TaxonomyRegion {
  name: string;
  focusAreas: string[];
}